import React from "react";
import { useNavigate } from "react-router";

export default function SupportPage() {
    const navigate = useNavigate()
  const handleLogout = () => {
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = "/login";
  };

  const goToProfile = () => {
    navigate("/pages/profile")
  };

  const handleFileChange = (e) => {
    
  };

  return (
    <div style={{
      maxWidth: "600px",
      margin: "40px auto",
      padding: "24px",
      borderRadius: "12px",
      backgroundColor: "#f0f4f8",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      fontFamily: "sans-serif",
      textAlign: "center"
    }}>
      <h2 style={{ color: "#3ab54b", marginBottom: "24px" }}>Account Actions</h2>

      <button onClick={handleLogout} style={buttonStyle("#e53935")}>
        Logout
      </button>

      <button onClick={goToProfile} style={buttonStyle("#1e88e5")}>
        Go to Profile
      </button>

      <div style={{ marginTop: "32px" }}>
        <label htmlFor="caVideo" style={{ display: "block", marginBottom: "8px", color: "#333", fontWeight: "bold" }}>
           CA Video
        </label>
        <input
          type="text"
          id="caVideo"
          accept="video/*"
          onChange={handleFileChange}
          style={{
            padding: "12px",
            border: "1px solid #ccc",
            borderRadius: "8px",
            backgroundColor: "#fff",
            cursor: "pointer",
            width: "100%",
            maxWidth: "300px"
          }}
        />
      </div>
    </div>
  );
}

function buttonStyle(color) {
  return {
    backgroundColor: color,
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "12px 24px",
    margin: "12px",
    cursor: "pointer",
    fontSize: "16px",
    transition: "background-color 0.3s"
  };
}
